import React from 'react'
import { useLocation } from 'react-router-dom'
import { CCol, CRow, CContainer, CDropdownDivider, CImage } from '@coreui/react'
import { AppContent, AppFooter, AppHeaderPagina, AppBreadcrumb } from '../components/index'
import Intranet from 'src/views/intranet/Intranet'

const PaginaLayout = () => {
  const currentLocation = useLocation().pathname

  return (
    <div>
      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeaderPagina />
        <div className="body flex-grow-1 mb-5">
          <CContainer fluid className="container-er">
            <CRow>
              <CCol>
                <AppBreadcrumb />
              </CCol>
            </CRow>
            <CRow className="mb-2 mt-4">
              {currentLocation.includes('/institucional') && (
                <>
                  <h1 className="titulo-sitios">Institucional</h1>
                  <CDropdownDivider></CDropdownDivider>
                </>
              )}
              {currentLocation.includes('/empleo-publico/intranet') ? (
                <>
                  <CImage
                    src="https://portal.entrerios.gov.ar/media/img/banner_intranet.jpg"
                    alt="Imagen Intranet."
                    style={{ objectFit: 'cover', aspectRatio: '1584/396' }}
                    width="100%"
                    height="100%"
                  ></CImage>
                  <h1 className="mt-5 titulo-sitios">Intranet</h1>
                  <CDropdownDivider></CDropdownDivider>
                </>
              ) : (
                currentLocation.includes('/empleo-publico') && (
                  <>
                    <h1 className="titulo-sitios">Empleado Público</h1>
                    <CDropdownDivider></CDropdownDivider>
                  </>
                )
              )}
            </CRow>
            <CRow>
              <CCol>
                <AppContent />
              </CCol>
            </CRow>
          </CContainer>
        </div>
        {/* {currentLocation.includes('/empleo-publico') &&
          !currentLocation.includes('/empleo-publico/intranet') && <Intranet></Intranet>} */}
        <AppFooter sitio="0" home={false} />
      </div>
    </div>
  )
}

export default PaginaLayout
